export default [
	{
		path: '/website_entertainments/:websiteEntertainmentId/editor/:lang/:type/:id',
		lazy: async () => {
			const Module = await import('../pages/Editor/EditorWebsiteEntertainmentPage');
			return { Component: Module.default };
		},
	},
	{
		path: '/configuration/editor/:lang/:type/:id',
		lazy: async () => {
			const Module = await import('../pages/Editor/EditorPage');
			return { Component: Module.default };
		},
	},
];
